export const decodePresignUrl = (url: string): string => {
  try {
    return decodeURIComponent(JSON.parse(`"${url}"`));
  } catch {
    return url;
  }
};
